import React, { useState, useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import request from "../../../Helpers/API"; // Asegúrate de que esta ruta sea correcta

const ClienteAutocomplete = ({ onSelectCliente, tipo }) => {
  const [clientesList, setClientesList] = useState([]);
  const [clientesearch, setClientesearch] = useState("");

  useEffect(() => {
    // Cargar la lista de clientes al montar el componente
    request
      .get(`ClientesEspeciales/DropDownList?tipo=${tipo}`)
      .then((result) => {
        setClientesList(result);
      })
      .catch((error) => {
        console.error("Error fetching clientes:", error);
      });
  }, []);

  return (
    <Autocomplete
      size="small" // Tamaño del Autocomplete
      freeSolo
      options={clientesList.map((option) => `${option.idCliente} - ${option.razon_social}`)}
      onChange={(event, newValue) => {
        const selectedCliente = clientesList.find(cliente => `${cliente.idCliente} - ${cliente.razon_social}` === newValue);
        if (selectedCliente) {
          // Llama al callback con el idCliente y la razon_social
          onSelectCliente(selectedCliente.idCliente, selectedCliente.razon_social);
        }
        setClientesearch(newValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Cliente"
          fullWidth // Asegúrate de que ocupe todo el ancho
          size="small" // Tamaño del TextField
          variant="outlined"
          sx={{
            mt: 2, // Margen superior
          }}
        />
      )}
    />
  );
};

export default ClienteAutocomplete;